import {
  Dialog,
  DialogContent,
  CardContent,
  Button,
  DataGrid,
  Box,
} from "../../../../components";

export default function PainelAnaliseFiscalProdutosGrupoTributarioDialog({
  open,
  setOpen,
  gruposIncorretos = [],
  gruposTributacao,
  revisarProdutoAnaliseFiscal,
}) {
  const gruposIncorretosColunas = [
    {
      field: "codigo",
      headerName: "Código",
      flex: 1,
      minWidth: 120,
    },
    {
      field: "descricao",
      headerName: "Produto",
      flex: 1,
      minWidth: 250,
    },
    {
      field: "csoCodigo",
      headerName: "Grupo Tributário Atual",
      flex: 1,
      minWidth: 120,
    },
    {
      field: "csoSugerido",
      headerName: "Grupo Tributário Sugerido",
      flex: 1,
      minWidth: 120,
    },
  ];

  async function handleRevisarGrupoTributario() {
    const mergeGrupos = gruposIncorretos
      .map((item) => {
        const grupoSugerido = gruposTributacao.find(
          ({ csoSimplesNacional }) => csoSimplesNacional === item.csoSugerido,
        );
        return {
          id: item.produtoId,
          grupoTributacaoId: grupoSugerido?.id || null,
        };
      })
      .filter((item) => item.grupoTributacaoId && item.produtoId);
    revisarProdutoAnaliseFiscal(mergeGrupos, setOpen);
  }

  return (
    <Dialog
      fullWidth
      maxWidth="md"
      PaperComponent="div"
      PaperProps={{
        style: {
          borderRadius: "0.7rem",
          background: "white",
        },
      }}
      open={open}
      onClose={() => setOpen(false)}
    >
      <DialogContent>
        <Box className="d-flex justify-content-between align-items-center my-2 mx-3">
          <h6 className="text-uppercase fw-bold pt-2">
            Produtos com Grupo Tributário Inconsistente
          </h6>
          <Button
            variant="contained"
            color="primary"
            disableElevation
            onClick={handleRevisarGrupoTributario}
          >
            Revisar
          </Button>
        </Box>
        <CardContent>
          <DataGrid
            rows={gruposIncorretos}
            columns={gruposIncorretosColunas}
            rowCount={gruposIncorretos.length}
            disableAcoes
          />
          <Box
            className="mt-4 p-3 d-flex justify-content-center align-items-center rounded-4"
            sx={{
              background: "#006eff27",
            }}
          >
            <i className="ph-fill ph-sparkle" /> Grupos Tributários são
            sugeridos por Inteligência Artificial e que requer validação junto
            ao departamento fiscal
          </Box>
        </CardContent>
      </DialogContent>
    </Dialog>
  );
}
